import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { Loader } from "../../components/Loader/Loader";
import { useSelector } from "../../hooks";
import { BusinessRoutes } from "./BusinessRoutes";

export const BusinessPage = () => {
    const { error, loading } = useSelector(store => store.businesses)

    return (
        <>
            <BusinessRoutes />

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}